import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=4388e60e"
import script from "./Campus.vue?vue&type=script&lang=js"
export * from "./Campus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports